import React from 'react';
import { TextInput } from '../../text-input';
import { CountryDropdown } from '../../country-dropdown';

export const addressFormat = {
  elements: [
    {
      id: 'name',
      name: 'name',
      required: true,
      placeholderMessageKey: 'name',
      labelClassName: 'name-label',
      renderComponent: (props) => <TextInput {...props} />,
    },
    {
      id: 'company',
      name: 'company',
      placeholderMessageKey: 'companyPlaceholder',
      renderComponent: (props) => <TextInput {...props} />,
    },
    {
      id: 'country',
      type: 'select',
      name: 'countryCode',
      placeholderMessageKey: 'country',
      required: true,
      renderComponent: (props) => <CountryDropdown {...props} />,
    },
    {
      id: 'line1',
      name: 'line1',
      required: true,
      placeholderMessageKey: 'address1Placeholder',
      renderComponent: (props) => <TextInput {...props} />,
    },
    {
      id: 'line2',
      name: 'line2',
      placeholderMessageKey: 'address2Placeholder',
      renderComponent: (props) => <TextInput {...props} />,
    },
    {
      id: 'line3',
      name: 'line3',
      placeholderMessageKey: 'address3Placeholder',
      renderComponent: (props) => <TextInput {...props} />,
    },
    {
      id: 'city',
      name: 'city',
      placeholderMessageKey: 'city',
      required: true,
      isInline: true,
      renderComponent: (props) => <TextInput {...props} />,
    },
    {
      id: 'state',
      name: 'state',
      placeholderMessageKey: 'state',
      componentClassName: 'state-input',
      required: true,
      isInline: true,
      renderComponent: (props) => <TextInput {...props} />,
    },
    {
      id: 'postalCode',
      labelClassName: 'postal-code-label',
      name: 'postalCode',
      placeholderMessageKey: 'postalCode',
      componentClassName: 'postal-code-input',
      required: true,
      isInline: true,
      renderComponent: (props) => <TextInput {...props} />,
    },
    {
      id: 'phone',
      name: 'phone',
      placeholderMessageKey: 'phone',
      componentClassName: 'phone-number',
      renderComponent: (props) => <TextInput {...props} />,
    },
    {
      id: 'email',
      name: 'email',
      placeholderMessageKey: 'email',
      componentClassName: '',
      renderComponent: (props) => <TextInput {...props} />,
    },
  ],
};
